import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
import { z } from 'zod';

extendZodWithOpenApi(z);

export const AdapterAnalysisCompleteRequest = z.object({}).openapi('AdapterAnalysisCompleteRequest');

export type AdapterAnalysisCompleteRequest = z.infer<typeof AdapterAnalysisCompleteRequest>;
